import api from './api';

const AttendanceService = {
  getAll: async (params = {}) => {
    const response = await api.get('/attendances/', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/attendances/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/attendances/', data);
    return response.data;
  },

  bulkCreate: async (attendances) => {
    const response = await api.post('/attendances/bulk_create/', { attendances });
    return response.data;
  },

  bulkSave: async (attendances) => {
    const response = await api.post('/attendances/bulk-save/', { attendances });
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/attendances/${id}/`, data);
    return response.data;
  },

  partialUpdate: async (id, data) => {
    const response = await api.patch(`/attendances/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/attendances/${id}/`);
    return response.data;
  }
};

export default AttendanceService;
